import { RegenerativePathCreate } from './regenerative-path-create.model';
import { PracticeAdditionalParameter } from '../../../common/_models';

export class RequirementManualVerification {
  required: boolean;
  key: string;
  optionsAlternative: string[];
  translationKey: string;

  constructor() {
    this.required = false;
    this.key = null;
    this.optionsAlternative = [];
    this.translationKey = '';
  }
}

export class RegenerativePathValidationFlags {
  checkDataActivities: boolean = false;
  checkDataSoilAnalysis: boolean = false;
  checkDataPlanCrop: boolean = false;
}
// Todo: reconsider move the class to regenerativePractice.ts
export class PracticeSelected {
  additionalParameters: PracticeAdditionalParameter[];
  userCreated: number;
  companyIdCreated: number;
  dateCreated: string;
  lastModify: string;
  companyId: number;
  id: string;
  name: string;
  type: string;
  startRequirements: string[];
  requirementsManualVerification: RequirementManualVerification[];
  manualVerification: boolean;
  satelliteVerification: boolean;
  imgUrl: string;

  constructor() {
    this.userCreated = null;
    this.companyIdCreated = null;
    this.dateCreated = null;
    this.lastModify = null;
    this.companyId = null;
    this.id = null;
    this.name = null;
    this.type = null;
    this.startRequirements = [];
    this.requirementsManualVerification = [];
    this.manualVerification = false;
    this.satelliteVerification = false;
    this.imgUrl = null;
  }
}

export class RegenerativePath extends RegenerativePathCreate {
  id: string;
  name: string;
  calcYear: number;
  baseYear: number;
  checkDataActivities: boolean;
  checkDataSoilAnalysis: boolean;
  checkDataPlanCrop: boolean;
  userCreated: number;
  companyIdCreated: number;
  dateCreated: string;
  lastModify: string;
  practicesSelected: PracticeSelected[];

  constructor() {
    super();
    this.id = null;
    this.name = null;
    this.calcYear = null;
    this.baseYear = null;
    this.checkDataActivities = false;
    this.checkDataSoilAnalysis = false;
    this.checkDataPlanCrop = false;
    this.userCreated = null;
    this.companyIdCreated = null;
    this.dateCreated = null;
    this.lastModify = null;
    this.practicesSelected = [];
  }

  get pathHasStarted(): boolean {
    return !!this.checkDataActivities && !!this.checkDataSoilAnalysis && !!this.checkDataPlanCrop;
  }
}
